import { find } from 'lodash';

import type { Choice, ChoicesResponse } from '../types';

const firstDefinedValue = (...values: any) =>
  find(values, (val) => typeof val !== 'undefined');

const normalizeChoices = (data: ChoicesResponse): Choice[] =>
  Array.isArray(data)
    ? // If the choices are provided as an array, generate keys from the `key` or `value` attributes.
      data.map((choice) => ({
        ...choice,
        key: firstDefinedValue(choice.key, choice.value),
      }))
    : // If the choices are provided as an object, convert that into an array of Choices.
      Object.keys(data).map((key) => ({
        key,
        label: data[key],
      }));

export default normalizeChoices;
